import { LazyAction, LazyModule } from 'owa-bundling';
import type * as lazyIndex from './writeFocusedOtherSearchFolderId';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () =>
        import(
            /* webpackChunkName: "WriteFocusedOtherSearchFolderId" */ './writeFocusedOtherSearchFolderId'
        ),
    { name: 'WriteFocusedOtherSearchFolderId' }
);

export const lazyWriteFocusedOtherSearchFolderId: LazyAction<
    typeof lazyIndex.default,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.default);
